import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import TopBar from "../__shared__/TopBar";
import ProfileMenu from "../__shared__/ProfileMenu";
import StepMarkerBar from "../__shared__/StepMarkerBar";
import PreviousStepButton from "../__shared__/PreviousStepButton";
import { connect } from "react-redux";
import {
    BIOPSY_STEP,
    EDIT_MARGIN_STEP,
} from "../CreateTPlan_1Upload/constants";
import {
    setCurrentTreatmentPlan,
    setStepActive,
    setStepComplete,
} from "../CreateTPlan_1Upload/actions";
import {
    clientErrorMessages,
    EMPTY_STRING,
    pageLoadStates,
    stepPath,
    SUCCESS,
} from "../../constants";
import PropTypes from "prop-types";
import { setErrorState } from "../../redux/error_banner/actions";
import * as TreatmentPlan from "../../helpers/tplan/tplan";
import { generateCPMLoadStates } from "./constants";
import CancerMapProgressTracker from "./CancerMapProgressTracker";
import FailureScreen from "../__shared__/FailureScreen";
import { updateTreatmentPlan } from "../../helpers/backend_api";
import { rootStore } from "../../redux/store";
import * as helpers from "./helpers";
import { planStageEnum } from "../__shared__/RequirementsModal/constants";
import { trackingEventNames } from "../../helpers/pendo_constants";
import UnfoldLogo from "../../ui/logos/UnfoldLogo";

class CreateTPlan_4_1_GenerateCPM extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadState: generateCPMLoadStates.CPM_GENERATING,
            mapProgressMessages: [],
            cemError: null,
            requestUuid: EMPTY_STRING,
        };

        this.prevStep = this.prevStep.bind(this);
        this.performSteps = this.performSteps.bind(this);
        this.generateCPM = helpers.generateCPM.bind(this);
    }

    componentDidMount() {
        this.performSteps();
    }

    prevStep() {
        this.props.setStepActive(EDIT_MARGIN_STEP, false);
        this.props.setStepComplete(EDIT_MARGIN_STEP, false);
        this.props.setStepActive(BIOPSY_STEP, true);

        let plan = this.props.currentTreatmentPlan;
        plan.SavedData.PlanCreationStep = BIOPSY_STEP;
        this.props.setCurrentTreatmentPlan(plan);

        updateTreatmentPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
            plan: plan,
        });
    }

    updateTreatmentPlanWithCEMFailure() {
        updateTreatmentPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
            plan: {
                MetaData: {
                    PlanStage: planStageEnum.CEM_FAILED,
                },
            },
        })
            .then((response) => response.json())
            .then((json) => {
                if (json.message === SUCCESS) {
                    this.props.setCurrentTreatmentPlan(json.payload.plan);
                }
            });
    }

    performSteps() {
        const tPlan = this.props.currentTreatmentPlan.TreatmentPlan;
        if (
            TreatmentPlan.getGleasonGradeGroup(tPlan) >= 2 &&
            TreatmentPlan.hasROIs(tPlan)
        ) {
            this.performIntermediateRiskPCaSteps();
        }
    }

    async performIntermediateRiskPCaSteps() {
        let scope = this;
        let plan = this.props.currentTreatmentPlan;

        plan.SavedData.OptimalCPMThreshold = 0.0;
        plan.SavedData.UserSelectedCPMThreshold = 0.0;
        plan.SavedData.OptimalMarksScore = 0.0;
        plan.SavedData.UserSelectedMarksScore = 0.0;
        plan.SavedData.OptimalLesionCoverageOfProstate = 0.0;
        plan.SavedData.UserSelectedLesionCoverageOfProstate = 0.0;
        plan.SavedData.IsPatientFTEligible = false;
        plan.SavedData.CPMURI = EMPTY_STRING;
        plan.SavedData.LesionConfirmed = false;

        await updateTreatmentPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
            plan: plan,
        })
            .then((payload) => payload.json())
            .then((json) => {
                scope.props.setCurrentTreatmentPlan(json.payload.plan);
            })
            .catch(() => {
                rootStore.dispatch(
                    setErrorState(
                        true,
                        trackingEventNames.UPDATE_PLAN,
                        this.props.planuuid,
                        clientErrorMessages.TPLAN_UPDATE_FAILED
                    )
                );
                scope.setState({ loadState: pageLoadStates.FAILED });
            });

        this.generateCPM();
    }

    getLoadingScreen() {
        let overlay;

        if (this.state.loadState === pageLoadStates.FAILED) {
            overlay = <FailureScreen />;
        } else {
            overlay = (
                <CancerMapProgressTracker
                    mapProgressMessages={this.state.mapProgressMessages}
                    cemError={this.state.cemError}
                />
            );
        }

        return overlay;
    }

    render() {
        return (
            <div className="create-plan-edit-margin-screen">
                <TopBar>
                    <Link to={stepPath.HOME}>
                        <UnfoldLogo />
                    </Link>
                    <div className="create-plan-step-bar-container">
                        <div className="step-bar-prev-btn-group">
                            <PreviousStepButton
                                to={stepPath.STEP3}
                                callback={this.prevStep}
                            />
                            <StepMarkerBar />
                        </div>
                    </div>
                    <ProfileMenu />
                </TopBar>
                {this.getLoadingScreen()}
            </div>
        );
    }
}

CreateTPlan_4_1_GenerateCPM.propTypes = {
    useruuid: PropTypes.string,
    authToken: PropTypes.string,
    visituuid: PropTypes.string,
    patientuuid: PropTypes.string,
    planuuid: PropTypes.string,
    currentTreatmentPlan: PropTypes.object,
    setCurrentTreatmentPlan: PropTypes.func,
    history: PropTypes.object,
    setErrorState: PropTypes.func,
    setStepActive: PropTypes.func,
    setStepComplete: PropTypes.func,
};

CreateTPlan_4_1_GenerateCPM.defaultProps = {
    useruuid: EMPTY_STRING,
    authToken: EMPTY_STRING,
    visituuid: EMPTY_STRING,
    patientuuid: EMPTY_STRING,
    planuuid: EMPTY_STRING,
    currentTreatmentPlan: {},
};

/* istanbul ignore next */
const mapStateToProps = function (state) {
    return {
        useruuid: state.LoginReducer.useruuid,
        authToken: state.LoginReducer.authToken,
        visituuid: state.CreatePlanReducer.visituuid,
        patientuuid: state.CreatePlanReducer.patientuuid,
        planuuid: state.CreatePlanReducer.planuuid,
        currentTreatmentPlan: state.CreatePlanReducer.currentTreatmentPlan,
    };
};

/* istanbul ignore next */
const mapDispatchToProps = function (dispatch) {
    return {
        setStepComplete: (stepIdx, isComplete) =>
            dispatch(setStepComplete(stepIdx, isComplete)),
        setStepActive: (stepIdx, isActive) =>
            dispatch(setStepActive(stepIdx, isActive)),
        setCurrentTreatmentPlan: (plan) =>
            dispatch(setCurrentTreatmentPlan(plan)),
        setErrorState: (hasError, errorText) =>
            dispatch(setErrorState(hasError, errorText)),
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CreateTPlan_4_1_GenerateCPM)
);
